import React, {Component} from 'react';
import {withAlert} from 'react-alert';
import {withRouter} from 'react-router-dom';
import {postRequest} from "../routes/Routes";
import '../assets/css/Home.css';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            codeSentSuccess: false,
            codeLengthError: false,
            resetPassword: false,
            passwordUnMatch: false,
            email: null,
            code: null,
            loading: false
        };
    }

    render() {
        return (
            <div className="container">
                <div className="login-component">
                    <h1 className="heading">volkslanka</h1>
                    <h3 className="form-heading">
                        {this.state.resetPassword ?
                            "Reset your password" :
                            this.state.codeSentSuccess ?
                                "Reset link was successfully sent to " + this.getHiddenEmail() :
                                "Enter your E-mail Address associated with you volkslanka account."
                        }
                    </h3>
                    <form onSubmit={this.handleSubmit}>
                        {this.state.resetPassword ?
                            [
                                <div className="form-group">
                                    <input type="number" className="form-control"
                                           placeholder='6-Digit Code' id="code" value={this.state.code} hidden/>
                                </div>,
                                <div className="form-group">
                                    <input type="password" className="form-control"
                                           placeholder='New Password' id="password" minLength="8" required/>
                                </div>,
                                <div className="form-group">
                                    <input type="password" className="form-control"
                                           placeholder='Confirm New Password' id="confirmPassword" minLength="8"
                                           required/>
                                </div>,
                                this.state.passwordUnMatch &&
                                <div className="alert alert-danger" role="alert">
                                    Passwords are not matching
                                </div>,
                                <button className="btn blue-button login-button" disabled={this.state.loading}>
                                    {this.state.loading ?
                                        <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                              aria-hidden="true"/>
                                        : null
                                    }Reset Password
                                </button>
                            ] :
                            this.state.codeSentSuccess ?
                                [
                                    <div className="form-group">
                                        <input type="number" className="form-control"
                                               placeholder='6-Digit Code' id="code" minLength="6" maxLength="6"
                                               onChange={this.checkCodeLength} required/>
                                    </div>,
                                    this.state.codeLengthError &&
                                    <div className="alert alert-danger" role="alert">
                                        Please enter 6 digits
                                    </div>,
                                    <span className="blue-font span-button" onClick={this.handleCodeNotReceived}>
                                        Didn't receive yet?
                                    </span>,
                                    <button className="btn blue-button login-button"
                                            disabled={this.state.codeLengthError || this.state.loading}>
                                        {this.state.loading ?
                                            <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                  aria-hidden="true"/>
                                            : null
                                        }Validate Code
                                    </button>
                                ] :
                                [
                                    <div className="form-group">
                                        <input type="email" className="form-control"
                                               placeholder='Email Address' id="email" required/>
                                    </div>,
                                    <button className="btn blue-button login-button" disabled={this.state.loading}>
                                        {this.state.loading ?
                                            <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                  aria-hidden="true"/>
                                            : null
                                        }
                                        Send Reset Code
                                    </button>
                                ]
                        }
                    </form>
                </div>
            </div>
        );
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({loading: true});
        if (this.state.resetPassword) {
            const password = event.target.password.value;
            const confirmPassword = event.target.confirmPassword.value;
            if (password !== confirmPassword) {
                this.setState({passwordUnMatch: true, loading: false});
            } else {
                let values = {
                    otp: event.target.code.value,
                    email: this.state.email,
                    password: password,
                    endpoint: '/api/users/reset-password'
                };
                postRequest(values).then(response => {
                    if (response.status === 200) {
                        if (response.data.error) {
                            this.props.alert.error(response.data.message);
                        } else {
                            this.setState({passwordUnMatch: false});
                            this.props.alert.success(response.data.message);
                            this.props.history.push({
                                pathname: "/login"
                            });
                        }
                    } else {
                        this.props.alert.error(response.data.message);
                    }
                    this.setState({loading: false});
                });
            }
        } else if (this.state.codeSentSuccess) {
            if (!this.state.codeLengthError) {
                let values = {
                    otp: event.target.code.value,
                    email: this.state.email,
                    endpoint: '/api/password-reset/validate'
                };
                postRequest(values).then(response => {
                    if (response.status === 200) {
                        if (response.data.error) {
                            this.props.alert.error(response.data.message);
                        } else {
                            this.setState({codeLengthError: false, resetPassword: true, code: event.target.code.value});
                        }
                    } else {
                        this.props.alert.error(response.data.message);
                    }
                    this.setState({loading: false});
                });
            }
        } else {
            let values = {
                email: event.target.email.value,
                endpoint: '/api/users/forgot-password'
            };
            postRequest(values).then(response => {
                if (response.status === 200) {
                    if (response.data.error) {
                        this.props.alert.error(response.data.message);
                    } else {
                        this.setState({codeSentSuccess: true, email: event.target.email.value});
                    }
                } else {
                    this.props.alert.error(response.data.message);
                }
                this.setState({loading: false});
            });
        }
    };

    handleCodeNotReceived = async (event) => {
        let values = {
            email: this.state.email,
            endpoint: '/api/users/forgot-password'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    this.props.alert.success(response.data.message);
                }
            } else {
                this.props.alert.error(response.data.message);
            }
            this.setState({loading: false});
        });
    };

    checkCodeLength = (event) => {
        event.preventDefault();
        const code = event.target.value;
        if (code.toString().length === 6) {
            this.setState({codeLengthError: false});
        } else {
            this.setState({codeLengthError: true});
        }
    };

    getHiddenEmail = () => {
        let email = this.state.email.indexOf('@');
        let startIndex = email * .2 | 0;
        let endIndex = email * .9 | 0;
        return this.state.email.slice(0, startIndex) +
            this.state.email.slice(startIndex, endIndex).replace(/./g, '*') +
            this.state.email.slice(endIndex);
    }
}

export default withAlert()(withRouter(ForgotPassword));